export default {
  tab: {
    index: 'Index',
    prospect: 'Prospect',
    valuation: 'Valuation',
    liquidity: 'Liquidity',
    marketAnomaly: 'Market Anomaly',
  },

  indexSummary: {
    totalVolume: 'Total Volume: ',
    totalValue: 'Total Value: ',
    bnVnd: 'Bn. VND',
  },
};
